export const SIDEBARCOLLAPSE = "SIDEBARCOLLAPSE";
